import { render, staticRenderFns } from "./CreatorBanner.vue?vue&type=template&id=b106fe4c&"
import script from "./CreatorBanner.vue?vue&type=script&lang=js&"
export * from "./CreatorBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports